module.exports = __webpack_public_path__ + "static/media/meat.2bffebb8.svg";